import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';

@Component({
  selector: 'app-attendance-create',
  templateUrl: './attendance-create.component.html',
  styleUrls: ['./attendance-create.component.css']
})
export class AttendanceCreateComponent implements OnInit {
  /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
  @ViewChild('myForm', {static: false}) myForm: NgForm;

  public attendaceForm:FormGroup;

  public hasRole:string = this.authservice.hasRole();

  constructor(private fb:FormBuilder,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AttendanceCreateComponent>,
    private authservice:AuthenticationService,
    ) {
     }

  ngOnInit(): void {
    this.createattendaceForm();
  }

  createattendaceForm(){
    this.attendaceForm = this.fb.group({
        working_on: ['',[Validators.required]]
    })
  }

  get attendaceFormValidate(){
    return this.attendaceForm.controls;
  }

  attendaceFormSubmit(){
    if(this.attendaceForm.invalid){
      return;
    }
    this.dialogRef.close(this.attendaceForm.value);
    this.attendaceForm.reset();
    this.myForm.resetForm();
    this.createattendaceForm();
  }

  cancel():void{
    this.dialog.closeAll();
  }


}
